module.exports = __webpack_public_path__ + "static/media/corporateStep1.4b5e3382.svg";